// extracted by mini-css-extract-plugin
export var categoryIcon = "_dj-5";
export var connectorContainer = "_dj-1";
export var connectorLine = "_dj-0";
export var minHeight0 = "_dj-6";
export var relativeUnitValueSelector = "_dj-2";
export var trifoldSelectorBody = "_dj-4";
export var trifoldSelectorList = "_dj-3";